import './styles.scss'
import React from 'react'
import ComingSoonModal from 'Components/UIComponent/ComingSoonModal'

const CoffeeSnake = (props) => {
  const { GameControls, setShowInfo, showInfo } = props

  return (
    <>
      <div className="snake-game-wrapper">
        <GameControls />
        <div className="snake-thumbnail">
          <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/coffeesnake.png" alt="thumbnailImage" />
        </div>
      </div>
      <ComingSoonModal showModal={showInfo} setShowModal={setShowInfo} showText={false} customClassName="game-thumbnail-modal" />
    </>
  )
}

export default CoffeeSnake
